import { render, staticRenderFns } from "./UpdateContract.vue?vue&type=template&id=728fc15e&scoped=true"
import script from "./UpdateContract.vue?vue&type=script&lang=js"
export * from "./UpdateContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fc15e",
  null
  
)

export default component.exports